/* eslint-disable @typescript-eslint/no-explicit-any */
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";

// 查询 我的-优惠券列表
export const getUserCouponList = (requestData: object) => {
  return newColorAxiosInstance
    .get(`user_coupon_getList`, {
      params: {
        ...requestData,
      },
    })
    .then((response: any) => response.data);
};
